import ContactForm from "../components/Contact";

const Contact = () => {
    return (
        <div className="w-full relative overflow-hidden">
            <div className="relative z-10">
                <ContactForm />
            </div>
        </div>
    );
};

export default Contact;